import { Link as MuiLink } from '@mui/material';
import { ReactElement } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import type {
  ClicksSummariesAttributes,
  ClicksSummariesResource,
} from '../../../../Entities/ClicksSummary';
import type { ReportGranularity } from '../../../../Components/ReportsWidget/utils';
import { getClicksListUrl } from './utils';

type ClickCountKey = keyof Pick<
  NonNullable<ClicksSummariesAttributes>,
  'total_clicks' | 'getprice_clicks' | 'future_clicks' | 'other_clicks'
>;

interface ClickCountLinkProps {
  record?: ClicksSummariesResource;
  source: ClickCountKey;
  granularity: ReportGranularity;
  refnameFilter?: Parameters<typeof getClicksListUrl>[2];
}

export default function ClickCountLink({
  record,
  source,
  granularity,
  refnameFilter,
}: ClickCountLinkProps): ReactElement | null {
  const value = record?.attributes?.[source];

  if (typeof value !== 'number') {
    return null;
  }

  return (
    <MuiLink
      component={RouterLink}
      to={getClicksListUrl(record?.attributes?.date, granularity, refnameFilter)}
      underline="hover"
    >
      {value.toLocaleString()}
    </MuiLink>
  );
}
